// Número só com dígitos para tel: e wa.me. Telefone brasileiro sem DDI
// (10 ou 11 dígitos) ganha o 55 na frente, que o wa.me exige.
export function digitosTelefone(telefone: string | null | undefined): string {
  const digitos = (telefone ?? '').replace(/\D/g, '');
  return digitos.length === 10 || digitos.length === 11 ? `55${digitos}` : digitos;
}

// Abre a conversa no WhatsApp (app no celular, WhatsApp Web no computador).
// null quando não há número utilizável.
export function linkWhatsApp(telefone: string | null | undefined): string | null {
  const digitos = digitosTelefone(telefone);
  return digitos.length >= 10 ? `https://wa.me/${digitos}` : null;
}

export function linkLigar(telefone: string | null | undefined): string | null {
  const digitos = digitosTelefone(telefone);
  return digitos.length >= 10 ? `tel:+${digitos}` : null;
}
